import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import {
  Account,
  ClientData,
  Portfolio,
  PortfolioElement,
} from "src/app/screens/user-profile/client-data";
import { AccountService } from "src/app/services/account.service";
import { OrderBuyComponent } from "../order-buy/order-buy.component";
import { UrlConstants } from "src/app/models/urlConstants";
import { Sort } from "@angular/material/sort";
import * as XLSX from "xlsx";
import { ToastrService } from "ngx-toastr";
import { MutualFund, FundDetails } from "src/app/models/mutualFund";
import { FundService } from "src/app/services/fund.service";
import { FundAccOrderModalComponent } from "../fund-acc-order-modal/fund-acc-order-modal.component";
import { Observable } from "rxjs/internal/Observable";
import { finalize, map, switchMap, takeUntil } from "rxjs/operators";
import { throwError } from "rxjs";

const compare = (v1: string | number, v2: string | number) =>
  v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

@Component({
  selector: "app-user-portfolio",
  templateUrl: "./user-portfolio.component.html",
  styleUrls: ["./user-portfolio.component.scss"],
})
export class UserPortfolioComponent implements OnInit {
  isProfileLoading: boolean = false;
  @Input() userPortfolio: Portfolio;
  searchPortfolio: Portfolio;
  sortedData: PortfolioElement[];
  sortDirection;
  sortActive;
  portfolioDataList;
  selectedAccount;
  isRequestLoading:boolean;
  accList: any;
  @Input() acc;
  @Input() currency;
  isTableVisible: boolean = true;
  totalMarginMarketValue: number =0;
  dtOptions: {
    // scrollX: true,
    paging: boolean;
    searching: boolean;
    autoWidth: boolean;
    info: boolean;
    responsive: boolean;
    fixedHeader: boolean;
    select: boolean;
    ordering: boolean;
    order: any[];
    sorting: any[];
  };
  accType:any;
  selectedFund: MutualFund;
  fundDetails: FundDetails; 
  isMargin: boolean;

  constructor(
    private http: HttpClient,
    private accService: AccountService,
    private dialog: MatDialog,
    public translate: TranslateService,
    private toastr: ToastrService,
    public fundService: FundService,
    private cdr: ChangeDetectorRef,
  ) {

    
    // this.onSelectClient(this.accList[0].relationCode);
  }
get totalMarginValue() {
  if (!this.portfolioDataList?.length) return 0;
  
  return this.portfolioDataList.reduce((sum, element) => {
    return sum + (Number(element.MarginMarketValue) || 0);
  }, 0);
}
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.acc) {
      this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
      this.selectedAccount = this.accList[0].relationCode;
      this.accType = this.accList.filter(x=>x.relationCode == this.accList[0].relationCode)[0]?.accountType
      this.isMargin = this.accList.filter(x=>x.relationCode == this.accList[0].relationCode)[0]?.IsMargin
    } else {
      this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
      this.selectedAccount = this.acc;    
      this.accType = this.accList.filter(x=>x.relationCode == this.acc)[0]?.accountType
      this.isMargin = this.accList.filter(x=>x.relationCode == this.acc)[0]?.IsMargin
    }
    this.isTableVisible = false;
    this.cdr.detectChanges(); // Trigger change detection
    setTimeout(() => {
      this.isTableVisible = true;
      this.cdr.detectChanges(); // Trigger change detection again
    });
    if (this.userPortfolio != null) {
      let arrWithOrderIcon: Portfolio;
      arrWithOrderIcon = this.userPortfolio
      this.userPortfolio.Portfolio = arrWithOrderIcon?.Portfolio?.map((item) => {
        return {
          ...item,
          hasOrders: (item.BlkSetteledQty > 0 || item.BlkTPlusZeroQty > 0 || item.BlkTPlusOneQty > 0) ? true : false
        }
      })
    }
    // this.fetchUserPortfolio();
  }
  orderBuy(company, isSell): void {
  this.isRequestLoading = true;

  this.getSelectedFund(company.SymbolCode)
    .pipe(
      switchMap((selectedFund) => {
        if (!selectedFund) {
          this.openOrderDialog(company, isSell);
        this.isRequestLoading = false;
          this.cdr.detectChanges();
          return throwError(() => new Error('No fund selected'));
        }

        this.selectedFund = selectedFund;
        return this.getMutualFundDetails(company.SymbolCode);
      }),
      finalize(() => {
        this.isRequestLoading = false;
          this.cdr.detectChanges();
      }),
    )
    .subscribe({
      next: (details) => {
        this.isRequestLoading = false;
          this.cdr.detectChanges();
        this.fundDetails = details;

        if (this.fundDetails) {
          this.openFundAccOrderModal(company, isSell);
        } else {
          this.openOrderDialog(company, isSell);
        }
      },
      error: () => {
        this.isRequestLoading = false;
      }
    });
}

private openOrderDialog(company, isSell): void {
  this.dialog.open(OrderBuyComponent, {
    disableClose: true,
    panelClass: 'order-dialog-container',
    data: {
      symbol: company.SymbolCode,
      custodianCode: company.CustodianCode,
      type: isSell,
      currentUser: this.selectedAccount,
    },
    direction: this.getDialogDirection(),
  });
}
private getDialogDirection(): 'rtl' | 'ltr' {
  return this.translate.currentLang === 'ar' ? 'rtl' : 'ltr';
}
private openFundAccOrderModal(company, isSell): void {
  const isBuy = !isSell;

  this.dialog.open(FundAccOrderModalComponent, {
    panelClass: 'modal-width',
    data: {
      quantityAvailable: company.AvbSetteledQty,
      isBuy,
      selectedFund: this.fundDetails,
      fundDetails: this.fundDetails,
      currentUser: this.selectedAccount,
    },
  });
}
  
  getSelectedFund(symbolCode: string): Observable<MutualFund | null> {
    return this.fundService.getMutualFundList(symbolCode).pipe(
      map(({ selectedFund }) => selectedFund || null) 
    );
  }
  
  getMutualFundDetails(symbolCode: string): Observable<FundDetails | null> {
    return this.fundService.getMutualFundDetails(symbolCode).pipe(
      map((details) => {
        if (details) {
          details.PdfsUrlsList = details.PdfsUrls ? details.PdfsUrls.split(",") : [];
          this.isRequestLoading=false;
          this.cdr.detectChanges();
          return details;
        }
        this.isRequestLoading=false;
          this.cdr.detectChanges();
        return null;
      })
    );
  }
  

  newOrder() {
    const dialogRef = this.dialog.open(OrderBuyComponent, {
      disableClose: true,
      panelClass: "order-dialog-container",
      data: { type: 0, currentUser: this.selectedAccount },
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  // fetchUserPortfolio() {
  //   this.isProfileLoading = true;
  //   this.http
  //     .get(
  //       `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${this.selectedAccount}`
  //     )
  //     .subscribe((res) => {
  //       this.isProfileLoading = false;
  //       this.userPortfolio = res as ClientData;
  //     });
  // }

  // get portfolioList() {
  //   switch (this.currency) {
  //     case "USD":
  //       return this.userPortfolio?.Portfolio?.USDPortfolio;
  //     case "Rated":
  //       return this.userPortfolio?.Portfolio?.RatedPortfolio;
  //     case "EGP":
  //       return this.userPortfolio?.Portfolio?.EGPPortfolio;
  //     default:
  //       return this.userPortfolio?.Portfolio?.EGPPortfolio;
  //   }
  // }
  ngOnInit(): void {
    this.dtOptions = {
      // scrollX: true,
      paging: false,
      searching: false,
      autoWidth: true,
      info: false,
      responsive: true,
      fixedHeader: true,
      select: false,
      ordering: false,
      order: [[10, "desc"]],
      sorting: [],
      // ajax: (dataTablesParameters: any, callback) => {
      //   this.fetchEGX("EGX30").subscribe((res) => {
      //     this.isCompaniesLoading = false;
      //     this.companies = res as CompanyList[];
      //     this.WindowResize();

      //     callback({
      //       recordsTotal: this.companies.length,
      //       data: [],
      //     });
      //   });
      // },
    };
  }

get portfolioData() {
  if (this.searchPortfolio?.Portfolio?.length > 0) {
    this.portfolioDataList = this.searchPortfolio?.Portfolio;
  } else if (this.userPortfolio?.Portfolio?.length > 0) {
    this.portfolioDataList = this.userPortfolio?.Portfolio;
  } else {
    this.portfolioDataList = null;
  }



  return this.portfolioDataList;
}
  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    if (val != "") {
      let temp;
      temp = { ...this.userPortfolio };

      temp.Portfolio =
        temp?.Portfolio.filter(function (d) {
          return (
            d.SymbolNameEn.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            d.SymbolNameAr.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            d.SymbolCode.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            d.ReutersCode.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            d.CustodianNameE.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            ) ||
            d.CustodianNameA.toLocaleLowerCase().includes(
              val.toLocaleLowerCase()
            )
          );
        }) || [];

      this.searchPortfolio = temp;
    } else this.searchPortfolio = this.userPortfolio;

    if (this.searchPortfolio != null) {
      let arrWithOrderIcon: Portfolio
      arrWithOrderIcon = this.searchPortfolio
      this.searchPortfolio.Portfolio = arrWithOrderIcon.Portfolio.map((item) => {
        return {
          ...item,
          hasOrders: (item.BlkSetteledQty > 0 || item.BlkTPlusZeroQty > 0 || item.BlkTPlusOneQty) ? true : false
        }
      })
    }
  }

  sortAfterSearch(list) {
    // let column = this.colsss.find((x) => x.name == this.sortActive);
    const data = list.slice();

    if (!this.sortActive || this.sortDirection === '') {
      this.portfolioDataList = data;
      this.sortedData = null;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = this.sortDirection === 'asc';
      switch (this.sortActive) {
        case 'symbol':
          return this.compare(this.translate.currentLang == "ar" ? a.SymbolNameAr : a.SymbolNameEn, this.translate.currentLang == "ar" ? b.SymbolNameAr : b.SymbolNameEn, isAsc);
        case 'qty':
          return this.compare(a.Qty, b.Qty, isAsc);
        case 'custodian':
          return this.compare((this.translate.currentLang == 'en') ? a.CustodianNameE : a.CustodianNameA, (this.translate.currentLang == 'en') ? b.CustodianNameE : b.CustodianNameA, isAsc);
        case 'current-price':
          return this.compare(a.MarketPrice, b.MarketPrice, isAsc);
        case 'cost-price':
          return this.compare(a.AvgCost, b.AvgCost, isAsc);
        case 'mkt-value':
          return this.compare(a.MarketValue, b.MarketValue, isAsc);
        case 'cost-value':
          return this.compare(a.CostValue, b.CostValue, isAsc);
        case 'gl':
          return this.compare(a.GL, b.GL, isAsc);
        case 'glpercent':
          return this.compare(a.GLPerc, b.GLPerc, isAsc);
        case 'weight':
          return this.compare(a.Weight, b.Weight, isAsc);
        default:
          return 0;
      }
    });
    return this.sortedData;
  }

  sortData(sort: Sort) {
    this.sortDirection = sort.direction;
    this.sortActive = sort.active;
    const data = this.portfolioDataList.slice();

    if (!sort.active || sort.direction === '') {
      this.portfolioDataList = data;
      this.sortedData = null;
      return;
    }


    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'symbol':
          return this.compare(this.translate.currentLang == "ar" ? a.SymbolNameAr : a.SymbolNameEn, this.translate.currentLang == "ar" ? b.SymbolNameAr : b.SymbolNameEn, isAsc);
        case 'qty':
          return this.compare(a.Qty, b.Qty, isAsc);
        case 'custodian':
          return this.compare((this.translate.currentLang == 'en') ? a.CustodianNameE : a.CustodianNameA, (this.translate.currentLang == 'en') ? b.CustodianNameE : b.CustodianNameA, isAsc);
        case 'current-price':
          return this.compare(a.MarketPrice, b.MarketPrice, isAsc);
        case 'cost-price':
          return this.compare(a.AvgCost, b.AvgCost, isAsc);
        case 'mkt-value':
          return this.compare(a.MarketValue, b.MarketValue, isAsc);
        case 'cost-value':
          return this.compare(a.CostValue, b.CostValue, isAsc);
        case 'gl':
          return this.compare(a.GL, b.GL, isAsc);
        case 'glpercent':
          return this.compare(a.GLPerc, b.GLPerc, isAsc);
        case 'weight':
          return this.compare(a.Weight, b.Weight, isAsc);
        default:
          return 0;
      }
    });
  }


  compare(a: number | string, b: number | string, isAsc: boolean) {
    var aValue = (typeof a === 'string') ? a.toLowerCase() : a;
    var bValue = (typeof b === 'string') ? b.toLowerCase() : b;
    return (aValue < bValue ? -1 : 1) * (isAsc ? 1 : -1);
  }

  @ViewChild("TABLE") table: ElementRef;
  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    ); //converts a DOM TABLE element to a worksheet

    // remove first column Buy/Sell "B/S"
    ws['!cols'] = [];
    ws['!cols'][0] = { hidden: true };

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "TRANSACTIONS");

    /* save to file */
    XLSX.writeFile(wb, "Client" + "Portfolio" + `${this.selectedAccount}` + ".xlsx")
    this.toastr.success("", this.translate.instant("successDocumentDownload"), {
      timeOut: 15000,
      positionClass: "toast-bottom-center",
      closeButton: true,
    });
  }
}
